import "@angular/compiler";
import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';
import { defineCustomElements } from '@ionic/pwa-elements/loader';
import { AnakinModule } from './anakin/anakin.module';
import { environment } from './environments/environment';

if (environment.production) {
	enableProdMode();
	console.debug = () => { };
}
const ionApp = document.querySelector('ion-app');
	if (ionApp) {
		ionApp.style.display = 'none';
	}
platformBrowserDynamic().bootstrapModule(AnakinModule);
defineCustomElements(window);